module.exports = __webpack_public_path__ + "static/media/bgr-news-block002.5d1cf100.svg";